<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

<salonmonster-tap-retry
  *ngIf="anErrorOccurred"
  (click)="loadCalendar()"
></salonmonster-tap-retry>

<div [hidden]="isLoading || anErrorOccurred">
  <mat-card class="smc-availability-card">
    <mat-card-title sm-center>{{ 'BOOKINGS.PICK_TIME' | translate }}</mat-card-title>

    <div fxLayout="wrap" fxLayout.xs="column" fxLayout.sm="column">
      <calendar
        fxFlex="50"
        (dateSelected)="onCellSelected($event)"
        (rangeChanged)="rangeChanged($event)"
        [disabledDates]="disabledDates"
        [currentDate]="currentDate"
        [firstAvailableDate]="firstAvailableDate"
        [hidden]="isLoading"
      ></calendar>

      <div fxFlex="50" [hidden]="isLoading">
        <div class="smc-times-container">
          <h3 sm-center>
            {{ selectedDate | salonMonsterDate : "EEEE, MMMM d, yyyy" }}
          </h3>
          <div *ngIf="!dayHasAvailability" sm-center>
            {{ 'BOOKINGS.NO_AVAILABILITY' | translate }}
          </div>

          <div fxLayout="wrap" *ngIf="dayHasAvailability">
            <mat-list fxFlex="33.333" class="smc-availability-list">
              <h3 mat-subheader sm-center>{{ 'BOOKINGS.MORNING' | translate }}</h3>
              <mat-list-item *ngFor="let tm of morning">
                <button
                  fxFlex
                  mat-button
                  tappable
                  (click)="onTimeSlotSelect(tm)"
                  class="smc-clickable-text"
                >
                  {{ tm | salonMonsterDate : "h:mm a" }}
                </button>
              </mat-list-item>
            </mat-list>

            <mat-list fxFlex="33.333" class="smc-availability-list">
              <h3 mat-subheader sm-center>{{ 'BOOKINGS.AFTERNOON' | translate }}</h3>
              <mat-list-item *ngFor="let tm of afternoon">
                <button
                  fxFlex
                  mat-button
                  tappable
                  (click)="onTimeSlotSelect(tm)"
                  class="smc-clickable-text"
                >
                  {{ tm | salonMonsterDate : "h:mm a" }}
                </button>
              </mat-list-item>
            </mat-list>

            <mat-list fxFlex="33.333" class="smc-availability-list">
              <h3 mat-subheader sm-center>{{ 'BOOKINGS.EVENING' | translate }}</h3>
              <mat-list-item *ngFor="let tm of evening">
                <button
                  fxFlex
                  mat-button
                  tappable
                  (click)="onTimeSlotSelect(tm)"
                  class="smc-clickable-text"
                >
                  {{ tm | salonMonsterDate : "h:mm a" }}
                </button>
              </mat-list-item>
            </mat-list>
          </div>

          <div sm-center *ngIf="showWaitList">
            <br /><br />
            {{ 'BOOKINGS.WAITLIST_PROMPT' | translate }}<br />
            <button mat-button (click)="addToWaitList()" tappable>
              {{ 'BOOKINGS.ADD_TO_WAITLIST' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
</div>
